// 長視頻 豎版一大左右滑動循環
// Alias of template 10
import Template10 from '../Template10'
export default Template10
